import { useState } from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
    Box, VStack, HStack, Text, Button, Spinner, Divider, FormControl, FormLabel, useToast
} from '@chakra-ui/react';
import AsyncSelect from 'react-select/async';
import { authAPI } from '../services/api';

const loadStudents = (input) =>
    authAPI.getStudents({ search: input, limit: 20 })
        .then(res => res.data.map(s => ({
            value: s.id,
            label: `${s.full_name} (${s.class?.name || '未分班'})`
        })));

const LunchSearchModal = ({ isOpen, onClose, onCancelSuccess }) => {
    const toast = useToast();
    const [searchStudent, setSearchStudent] = useState(null);
    const [searchOrders, setSearchOrders] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    const handleClose = () => { setSearchStudent(null); setSearchOrders([]); onClose(); };

    const handleStudentChange = async (option) => {
        setSearchStudent(option);
        if (!option) { setSearchOrders([]); return; }
        setSearchLoading(true);
        try {
            const res = await authAPI.lunch.getOrders({ student_id: option.value, limit: 200 });
            const sorted = (res.data || []).sort((a, b) => a.date < b.date ? 1 : -1);
            setSearchOrders(sorted);
        } catch (e) {
            toast({ title: '查詢失敗', status: 'error' });
        } finally { setSearchLoading(false); }
    };

    const handleCancelOrder = async (orderId) => {
        try {
            await authAPI.lunch.cancelOrder(orderId);
            setSearchOrders(prev => prev.filter(o => o.id !== orderId));
            toast({ title: '已取消', status: 'success', duration: 2000 });
            if (onCancelSuccess) onCancelSuccess();
        } catch (e) {
            toast({ title: '取消失敗', status: 'error' });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="md" scrollBehavior="inside">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>搜尋學生訂餐紀錄</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <FormControl mb={4}>
                        <FormLabel fontSize="sm">選擇學生</FormLabel>
                        <AsyncSelect
                            loadOptions={loadStudents}
                            value={searchStudent}
                            onChange={handleStudentChange}
                            placeholder="輸入姓名搜尋..."
                            isClearable
                            noOptionsMessage={() => '輸入至少 1 個字開始搜尋'}
                            loadingMessage={() => '搜尋中...'}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        />
                    </FormControl>
                    {searchLoading && <Box textAlign="center" py={4}><Spinner color="orange.400" /></Box>}
                    {!searchLoading && searchStudent && searchOrders.length === 0 && (
                        <Text textAlign="center" color="gray.400" py={4}>{searchStudent.label} 無訂餐紀錄</Text>
                    )}
                    {!searchLoading && searchOrders.length > 0 && (
                        <VStack align="stretch" spacing={0} divider={<Divider />}>
                            <Text fontSize="sm" color="gray.500" mb={2}>共 {searchOrders.length} 筆訂餐</Text>
                            {searchOrders.map(o => (
                                <HStack key={o.id} py={2} justify="space-between">
                                    <Text fontSize="sm" fontWeight="500">{String(o.date)}</Text>
                                    <Button size="xs" colorScheme="red" variant="ghost" onClick={() => handleCancelOrder(o.id)}>取消</Button>
                                </HStack>
                            ))}
                        </VStack>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default LunchSearchModal;
